import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Navigate,
  RouterProvider,
  useLocation,
  useNavigationType,
} from "react-router-dom"

// theme
import { createGlobalStyle, ThemeProvider } from "styled-components"
import { theme } from "../themes/theme"
// routes
import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import { BPO, BPOResult, Home, Platform, Root } from "../routes"
import { PlatformResult } from "../routes/platform_result"

let myCreateBrowserRouter = createBrowserRouter

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
    ],
    tracesSampleRate: 1.0,
  })

  myCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter)
}

const router = myCreateBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <Navigate to="/" replace />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "/bpo",
        element: <BPO />,
      },
      {
        path: "/bpo/result",
        element: <BPOResult />,
      },
      {
        path: "/platform",
        element: <Platform />,
      },
      {
        path: "/platform/result",
        element: <PlatformResult />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
])

const GlobalStyle = createGlobalStyle`
    body {
      background-color: ${(props) => props.theme.colors.bodyBackground};
      font-family: ${(props) =>
        `${props.theme.fontFamilyEN}, ${props.theme.fontFamilyJA}, 'sans-serif'`};
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      color: ${(props) => props.theme.colors.text};
    }
    fieldset {
      border: none;
      margin: 0;
      padding: 0;
    }
    input {
      margin: 0;
    }
  
    #root {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  `

const AppProvider = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <RouterProvider router={router} />
    </ThemeProvider>
  )
}

export { AppProvider }
